export const CUSTOMER = "customer";
export const COMPANY = "company";
export const DROPSHIP = "dropship";
export const REPAIR_STATION = "repair_station";

export const SHIPPING_TYPES = [CUSTOMER, COMPANY, DROPSHIP, REPAIR_STATION];

export const shipToOptions = [
  {
    text: "Customer Physical Address",
    value: CUSTOMER
  },
  {
    text: "Company",
    value: COMPANY
  },
  {
    text: "Other",
    value: DROPSHIP
  }
];



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/shared/FormSections/ShippingSection/shippingTypes.js